module.exports = __webpack_public_path__ + "static/media/image-card-3.2ca6456f.png";